import * as types from '@/store/mutation-types';

const getters = {
  showErrorMessage: state => state.showErrorMessage,
  errorMessage: state => state.errorMessage,
};

const actions = {
  showErrorMessage({ commit, dispatch }, errorMessage) {
    if (
      errorMessage.toLowerCase().indexOf('permission') >= 0 ||
      errorMessage.toLowerCase().indexOf('credentials') >= 0 ||
      errorMessage.toLowerCase().indexOf('token') >= 0
    ) {
      dispatch('setLogoutState');
      console.log('error ' + errorMessage);
    }
    else commit(types.SHOW_ERROR, errorMessage);
  },
};

const mutations = {
  [types.SHOW_ERROR](state, payload) {
    state.showErrorMessage = true;
    if (
      payload.toLowerCase().indexOf('permission') >= 0 ||
      payload.toLowerCase().indexOf('credentials') >= 0 ||
      payload.toLowerCase().indexOf('token') >= 0
    ) state.errorMessage = "Sitzung abgelaufen";
    else if (payload.indexOf('Fehler') >= 0) state.errorMessage = payload;
    else if (payload.indexOf('No internet') >= 0)
      state.errorMessage =
        'Keine Internetverbindung. Für die Datenverarbeitung ist eine Internetbindung notwendig.';
    else
      state.errorMessage =
        'Leider ist ein Problem aufgetreten, bitte versuchen Sie es später erneut.';
    setTimeout(() => {
      state.showErrorMessage = false;
    }, 3000);
  },
};

const state = {
  showErrorMessage: false,
  errorMessage: null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
